<template>
    <v-dialog
        v-model="visible"
        width="500"
    >
        <v-card>
            <v-card-title style="font-size: 2em">
                Delete Challenge?
            </v-card-title>
            <v-card-text style="font-size: 1.3em">
                This action cannot be undone.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                color="orange"
                text
                @click="visible = false"
                >
                Cancel
                </v-btn>
                <v-btn
                color="orange"
                text
                @click="confirmDeleteChallenge(challenge)"
                >
                Confirm
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DeleteChallengeDialog',

  props: ['visible', 'challenge'],

  computed: {
    ...mapState(['auth'])
  },

  methods: {
    ...mapActions(['requestDeleteChallenge']),

    confirmDeleteChallenge (challenge) {
      // this.requestDeleteChallenge(challenge)
      this.$emit('update:visible', false)
      this.$emit('confirm', challenge)
    }
  }
}
</script>
